// SPDX-FileCopyrightText: 2026 Ebiose AI
// SPDX-License-Identifier: LicenseRef-Ebiose-Proprietary
// All rights reserved. Confidential — unauthorized distribution prohibited.

import { FaSpinner } from "react-icons/fa6"

export const Spinner = () => {
  return (
    <div className="flex items-center justify-center">
      <div className="animate-spin">
        <FaSpinner />
      </div>
    </div>
  )
}

export const SpinnerWithText = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-row gap-2 items-center justify-center text-lg text-neutral-500">
      <Spinner />
      {text}
    </div>
  )
}

export const FullPageSpinnerWithText = ({ text }: { text: string }) => {
  return (
    <div className="flex flex-col items-center justify-center h-full">
      <SpinnerWithText text={text} />
    </div>
  )
}
